import React, { useState, useEffect, Fragment, useRef, useMemo } from "react";
import ReactDOM from "react-dom";
import useRequireAuth from "../../utils/useRequireAuth";
import {
  useFetchCustomerUseListDataQuery,
  useFetchCommonDataQuery,
  useLazyFetchLinkedSectionsFieldsQuery,
  useLazyFetchFieldValuesQuery,
  useFetchAllTemplateQuery,
} from "../../utils/customer/customerSelect";
import DatePicker from "react-datepicker";
// import {useFetchTaskGetOrgAccordingQuery} from "../../utils/customer/customerTaskTable"
import { FaArrowRight, FaBedPulse } from "react-icons/fa6";
import "react-datepicker/dist/react-datepicker.css";
import { saveTasks, hideMessage } from "../../utils/customer/customerTaskSlice";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import OwnerDropDown from "../GlobalFeature/Fields/OwnerDropDown";
import { useLazyFetchPersonInTableQuery, useLazyFetchRandomUserQuery } from "../../utils/customer/customerTable";
import { useFetchCustomerAllTaskPodDataQuery } from "../../utils/customer/customerSelect";
import useCustomFormValidation from "../../hooks/ErrorHandling/useCustomFormValidation";
import { ReactComponent as DownArrow } from "../../assets/images/downArrow.svg";
import { CUSTOMER_DELETE_NOTES_ATTACHMENT, NODE_URL } from "../../utils/constants";
import useDebounce from "../GlobalFeature/useDebounce";
import { deleteData } from "../store/customer/CustomerSocialAddUpdateFunction";

import dayjs from "dayjs";
import TaskFormValidation from "../../hooks/ErrorHandling/TaskFormValidation";
import CustomerEditTaskActivity from "../customer/CustomerEditTaskActivity";
import { ReactComponent as CloseModalImg } from "../../assets/images/closeModalImg.svg";
import { ReactComponent as SubTaskIcon } from "../../assets/images/icons/SubTaskIcon.svg";
import {
  useCreateJobMutation,
  useFetchAllTaskPodsQuery,
  useFetchCustomerTaskPodAllCustomerDataQuery,
  useLazyFetchAllProjectsQuery,
  useLazyFetchServiceListQuery,
  useLazyGetProjectTaskEnumQuery,
  useLazyGetTaskTagsQuery,
  usePostApiMutation,
  usePostNoteAttachmentMutation,
  usePostTaskTagsMutation,
} from "../../utils/customer/customerTaskTable";
import { ReactComponent as MenuBar } from "../../assets/images/icons/SideMenu.svg";
import { ReactComponent as LinkTask } from "../../assets/images/icons/LinkTask.svg";
import { ReactComponent as AttachmentTask } from "../../assets/images/icons/AttachmentTask.svg";
import { ReactComponent as SubTaskIconClosed } from "../../assets/images/subtaskClosedIcon.svg";
import { ReactComponent as SubTaskHeader } from "../../assets/images/icons/SubTaskHeader.svg";
import { pushAlert } from "../../utils/alertSlice";
import FieldElements from "./FieldElements2";
import CustomDrawer from "../UniversalComponents/CustomDrawer";
import ConfirmationDialogBox from "../UniversalComponents/ConfirmationDialogBox";
import AddNewPodModal from "./AddNewPodModal";
import AddViewProjectDrawer from "../TaskPod/AddViewProjectDrawer";
import { areObjectsSimilar } from "../../utils/utilityFunctions/stringUtility";
import { hideLoader, showLoader } from "../../utils/loaderSlice";
import LinkedDrawer from "../TaskPod/LinkedDrawer";
import { getDatePlusOne } from "../../utils/utilityFunctions/dateUtility";
import LabelComponent from "../UniversalComponents/LabelComponent";
import SubDrawerRenderer from "../UniversalComponents/SubDrawerRenderer";
import FunnelSubDrawer from "./FunnelSubDrawer";
import { useLazyFetchFunnelTypeQuery } from "../../utils/customer/funnelSlice";
import DateTimeRecurence from "./DateTimeRecurence";
import { transformFormPayload } from "../../utils/utilityFunctions/TransformPayload";
import AttachmentSubDrawer from "./AttachmentSubDrawer";
import SubTaskListSubDrawer from "./SubTaskListSubDrawer";
import { getUserToken } from "../../utils/utilityFunctions/localServices";
import LinkedDocsCard from "../TaskPod/LinkedDocsCard";
import List from "../UniversalComponents/ListComponent";
import withPortalHOC from "../UniversalComponents/WithPortalHOC";
const formDisabledStatuses = ["Completed", "Drop", "Cancelled"];

const PortalList = withPortalHOC(List);

let tags_data = [
  { tag_name: "tag1", colour: "#FF5733" },
  { tag_name: "tag2", colour: "#33FF57" },
  { tag_name: "tag3", colour: "#3357FF" },
  { tag_name: "tag4", colour: "#F3F33F" },
  { tag_name: "tag5", colour: "#FF33A1" },
  { tag_name: "tag6", colour: "#A1FF33" },
  { tag_name: "tag7", colour: "#33A1FF" },
  { tag_name: "tag8", colour: "#FFB533" },
  { tag_name: "tag9", colour: "#33FFB5" },
  { tag_name: "tag10", colour: "#B533FF" },
];

function extractOtherSections(data) {
  if (!data) return [];
  const fields = [];
  for (const [key, value] of Object.entries(data)) {
    if (
      key !== "Task Information" &&
      key !== "Project Information" &&
      key !== "Service Information" &&
      Array.isArray(value.fields)
    ) {
      fields.push(...value.fields);
    }
  }
  return fields;
}

export const GetHeaderLabel = ({
  customerTask,
  taskid,
  isOpenSubTask,
  RowData,
  isDuplicateTask,
  isCopyToTask,
  isSubTask,
  isParentTask,
  handleNavigateParent,
}) => {
  // Priority overrides
  if (isDuplicateTask)
    return (
      <div className="flex items-end justify-start gap-x-1">
        <span className="flex items-center gap-x-1 text-[#131313CC]">Add Task</span>
      </div>
    );
  if (isCopyToTask) return <span className="flex items-center gap-x-1 text-[#131313CC]">Add to</span>;

  // Existing logic

  if (isOpenSubTask) {
    return (
      <span className="flex items-end justify-start">
        <SubTaskIcon />
        <span className="flex items-center text-primary-80 hover:bg-primary-hover px-2 rounded-sm cursor-pointer truncate  text-ellipsis max-w-[25ch]">
          {RowData?.subject}
        </span>
        <span className="text-sm text-[#004EFFCC] text-ellipsis pb-[1px] truncate overflow-hidden min-w-0 grow">
          (Parent)
        </span>
      </span>
    );
  }

  if (isSubTask) {
    return (
      <div className="flex items-center gap-x-1 w-full">
        <div className="flex items-center justify-center h-7">
          <SubTaskIconClosed />
        </div>

        <div className="flex items-end  min-w-0 grow">
          <span
            className="text-primary-80 hover:text-primary-90 hover:bg-primary-hover px-2 rounded-sm cursor-pointer truncate  text-ellipsis max-w-[25ch] overflow-hidden"
            onClick={handleNavigateParent}
          >
            {taskid?.parent_subject}
          </span>

          <span className="text-sm text-[#004EFFCC] text-ellipsis pb-[1px] truncate overflow-hidden min-w-0 grow">
            (Parent)
          </span>
        </div>
      </div>
    );
  }
  if (taskid?.id)
    return (
      <span className="text-[#131313CC] text-ellipsis truncate overflow-hidden min-w-0 grow">
        {taskid?.customer_name}
      </span>
    );

  return taskid?.id ? "Edit" : "Add Task";
};
const DynamicAddTaskPodModal = ({
  isOpen,
  closePopup,
  taskid,
  refetch = () => {},
  leadTypeValue,
  disableLeadTypeChange,
  onClose,
  selectedCustomer,
  checkListOpen,
  setCheckListOpen,
  customerTask,
  customerData,
  setLeadTypeValue = () => {},
  openSubTaskDrawer,
  // isDoubleComp = false,
  recurModal,
  activeModal,
  templateId,
  setTemplateId,
  propTemplateId,
  refetchGetAllTasks = () => {},
  isMyActivity = false,
  externalApi = false,
  RowData = null, // rowData
  handleSubTaskCardClick,
  handleNavigateParent = () => {},
  linkDocumentPreview = false,
  setLinkDocumentPreview = () => {},
}) => {
  const token = useRequireAuth();

  const completeAuth = useRequireAuth();

  const { id: customerId } = useParams();
  const dispatch = useDispatch();
  const location = useLocation();
  const companyLocalData = localStorage.getItem("company_data");
  const userData = localStorage.getItem("myUserData");
  const userId = JSON.parse(userData).user_id;
  const [selectedFiles, setSelectedFiles] = useState(taskid ? taskid?.attachments : []);
  console.log("recurModal", recurModal);
  const parsedCompanyData = JSON.parse(companyLocalData);
  const [contactName, setContactName] = useState(null);
  const [isReccurOpen, setIsReccurOpen] = useState(recurModal);
  const [showTime, setShowTime] = useState(true);
  const [showEndDate, setShowEndDate] = useState(false);
  const [fullHeaderObject, setFullHeaderObject] = useState(null);
  const [isAttachmentOpen, setIsAttachmentOpen] = useState(taskid?.isAttachment ?? false);
  const [subTaskList, setSubTaskList] = useState(false);
  const [isSearchBarOpen, setIsSearchBarOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [customerSearch, setCustomerSearch] = useState("");
  const taskassignedtoref = useRef(null);
  const isFirstRender = useRef(true);
  const [showSubtaskForm, setShowSubtaskForm] = useState(openSubTaskDrawer);
  const storedData = localStorage.getItem("company_data");
  const companyId = storedData ? JSON.parse(storedData) : null;
  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);
  const [openAddNewPodModal, setOpenAddNewPodModal] = useState(false);
  const [subTaskSelected, setSubtaskSelected] = React.useState({});
  const [openAddProject, setOpenAddProject] = useState(false);
  const [subTaskSerial, setSubTaskSerial] = useState(1);
  const [checklistSerial, setChecklistSerial] = useState(1);
  const [isLinkOpen, setIsLinkOpen] = useState(taskid?.isLinkTask);
  const [preSelectedCustomer, setPreSelectedCustomer] = useState({});
  const [isFunnelOpen, setIsFunnelOpen] = useState(false);
  const [headerField, setHeaderField] = useState(null);
  const [selectedSectionLabel, setselectedSectionLabel] = useState();
  const [dropdownOptionsMap, setDropdownOptionsMap] = useState([]);
  const [templateFormated, setTemplateFormated] = useState(null);
  const [getAllFunnel, setGetAllFunnel] = useState(null);
  const [funnelStages, setFunnelStages] = useState([]);
  const [linkedStageTask, setLinkedStageTask] = useState(null);
  const [activeFunnel, setActiveFunnel] = useState(null);
  const [categoryList, setCategoryList] = useState(false);
  const drawerRef = useRef(null);

  const hasMyActivities = location.pathname.includes("my-activities")
    ? 1
    : location.pathname.includes("my-assignment")
      ? 0
      : null;

  const escapeRegExp = (string) => {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  };

  const highlightText = (text, query) => {
    console.log(text, "text");

    if (!text || !query) return text || "";

    const textStr = String(text);
    const words = query.trim().split(/\s+/).filter(Boolean);

    try {
      const regex = new RegExp(`(${words.map(escapeRegExp).join("|")})`, "gi");
      const parts = textStr.split(regex);
      return parts.map((part, index) =>
        regex.test(part) ? (
          <span
            key={index}
            style={{ all: "unset", backgroundColor: "#fde68a" }} // overrides text-transform: capitalize
          >
            {part}
          </span>
        ) : (
          part
        )
      );
    } catch (error) {
      return textStr;
    }
  };

  const parseWeeklyDays = (daysString) => {
    if (!daysString) {
      return [];
    }

    try {
      return JSON.parse(daysString);
    } catch (error) {
      return [];
    }
  };
  const initialWeeklyDays = taskid?.weekly_days
    ? parseWeeklyDays(taskid.weekly_days)
    : ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"];

  const [
    FetchFieldDropDownValues,
    { data: GetFieldValues, isError: isFieldValuesError, isSuccess: isFieldValuesSuccess, error: FieldValuesError },
  ] = useLazyFetchFieldValuesQuery();

  const [
    postNoteAttachment,
    {
      isLoading: postNoteAttachmentLoading,
      isSuccess: postNoteAttachmentSuccess,
      isError: postNoteAttachmentError,
      data: postNoteAttachmentData,
    },
  ] = usePostNoteAttachmentMutation();

  const {
    data: customerTaskPodAllCustomer,
    isLoading: customerTaskPodAllCustomerLoading,
    isSuccess: customerTaskPodAllCustomerSuccess,
  } = useFetchCustomerTaskPodAllCustomerDataQuery({
    token,
    companyId,
    search: customerSearch,
  });

  //funnel api
  const [fetchFunnelTypes, { data: funnelType, refetch: refetchFunnelTypes }] = useLazyFetchFunnelTypeQuery();
  useEffect(() => {
    fetchFunnelTypes({ id_deployed: true });
  }, []);

  const {
    refetch: refetchGetAllTemplate,
    data: GetAlltemplates,
    isLoading: isGetAllTemplatesLoading,
    isError: isGetAllTemplatesError,
    isSuccess: isGetAllTemplatesSuccess,
    error: GetAllTemplatesError,
  } = useFetchAllTemplateQuery({ myActivities: hasMyActivities });

  //post the task pod data
  const [
    createUpdateTask,
    {
      data: taskPodData,
      isLoading: isTaskPodLoading,
      isError: isTaskPodError,
      isSuccess: isTaskPodSuccess,
      error: TaskPodErrordata,
    },
  ] = usePostApiMutation();
  // for dynamic fields;
  const [
    GetLinkedSectionFields,
    {
      data: fetchLinkedSectionFields,
      isLoading: isFetchLinkedSectionFieldsLoading,
      isError: isFetchLinkedSectionFieldsError,
      isSuccess: isFetchLinkedSectionFieldsSuccess,
      error: FetchLinkedSectionFieldsError,
    },
  ] = useLazyFetchLinkedSectionsFieldsQuery();

  useEffect(() => {
    if (isFetchLinkedSectionFieldsLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }

    if (isFetchLinkedSectionFieldsSuccess && fetchLinkedSectionFields?.status) {
      if (fetchLinkedSectionFields?.data) {
        const enhancedData = Object.entries(fetchLinkedSectionFields?.data).reduce(
          (acc, [sectionLabel, sectionData]) => {
            acc[sectionLabel] = {
              ...sectionData,
              fields: sectionData?.fields.map((field) => ({
                ...field,
                apiCall: async () => fetchAndSetFieldOptions(field),
              })),
            };
            return acc;
          },
          {}
        );

        setHeaderField(enhancedData);
        setFullHeaderObject(fetchLinkedSectionFields);
        setFormData({
          ...formData,
          funnel_id: taskid ? fetchLinkedSectionFields?.funnel?.id : fetchLinkedSectionFields?.funnel?.id || "null",
        });
      }
    }

    if (isFetchLinkedSectionFieldsError) {
      dispatch(
        pushAlert({
          message: FetchLinkedSectionFieldsError?.data?.message || "Failed to fetch section fields",
          type: "danger",
          visible: true,
        })
      );
    }
  }, [
    isFetchLinkedSectionFieldsLoading,
    isFetchLinkedSectionFieldsSuccess,
    isFetchLinkedSectionFieldsError,
    fetchLinkedSectionFields,
  ]);

  useEffect(() => {
    if (!selectedSectionLabel && headerField) {
      const firstLabel = Object.keys(headerField)[0];
      setselectedSectionLabel(firstLabel);
    }
  }, [headerField, selectedSectionLabel]);

  useEffect(() => {
    if (selectedSectionLabel && sectionRefs.current[selectedSectionLabel]) {
      sectionRefs.current[selectedSectionLabel].scrollIntoView({ behavior: "smooth" });
    }
  }, [selectedSectionLabel]);

  //post the task pod data useEffect
  useEffect(() => {
    //loading
    if (isTaskPodLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }

    //try block
    if (isTaskPodSuccess) {
      dispatch(
        pushAlert({
          message: taskPodData?.message,
          type: taskPodData.success || taskPodData.success ? "success" : "danger", // success is not comming form backend
          visible: true,
        })
      );
      refetchGetAllTasks();
      closePopup();
    }

    // catch block
    if (isTaskPodError) {
      dispatch(pushAlert({ message: TaskPodErrordata?.data?.message, type: "danger", visible: true }));
    }
  }, [isTaskPodSuccess, isTaskPodError, isTaskPodLoading, taskPodData]);

  useEffect(() => {
    if (funnelType?.data?.length > 0) {
      setGetAllFunnel(funnelType?.data);
    }
  }, [funnelType?.data]);

  useEffect(() => {
    getServiceList();
    fetchAllProjectsCall();
  }, []);

  const initialFormData = {
    ...taskid,

    id: taskid?.id || "",
    customer_name: taskid?.customer_name ?? "",
    customer_id: (taskid?.customer_id || RowData?.customer_id) ?? "",
    ...(taskid?.fullHeaderObject?.funnel?.id ?? { funnel_id: taskid?.fullHeaderObject?.funnel?.id }), //vinay
    customer_display_name: taskid?.customer_display_name || "",
    remarks: "",
    subject: taskid?.subject || "",
    category_id:
      (taskid?.category_id === "all" ? "task" : taskid?.category_id) ||
      (leadTypeValue === "all" ? "task" : leadTypeValue) ||
      "",
    priority: taskid?.priority || "Medium",
    description: taskid?.description || "",
    status: taskid?.status || "Not started",
    task_pod: taskid?.task_pod,
    // start_date: extractDateAndTime(taskid?.start_date).date || "",
    // end_date: extractDateAndTime(taskid?.end_date).date || "",
    // start_time: taskid?.start_time || extractDateAndTime(taskid?.start?.value).time || "",
    // end_time: taskid?.end_time || extractDateAndTime(taskid?.end?.value).time || "",
    start_date: taskid?.start_date || "",
    end_date: taskid?.end_date || "",
    start_time: taskid?.start_time,
    end_time: taskid?.end_time,
    selection: taskid?.selection,
    assigned_to: taskid?.assigned_to || [],
    is_recurrence: taskid?.is_recurrence || "",
    recurrence_pattern_id: taskid?.recurrence_pattern_id || "",
    radioselected: "",
    every_weekday: "",
    after_occur: "",
    modifiedspecific: "",

    frequency: taskid?.frequency || "daily",
    interval: taskid?.intervals || 1,
    every_weeks: "",
    daily_recur: "",
    monthly_recur: "",
    yearly_recur: "",
    occurrences: "",
    daily_option: taskid?.daily_option || "every_n_days",
    weekly_days: initialWeeklyDays,
    endBy: "end_by",
    monthly_option: taskid?.monthly_option || "specific_day",
    monthly_week: taskid?.monthly_week || "first",
    day_of_week: taskid?.day_of_week,
    day_of_month: taskid?.day_of_month,
    yearly_option: taskid?.yearly_option || "specific_year",
    sub_tasks: taskid?.sub_tasks || [],
    checklists: taskid?.checklists || [],
    // category_id: taskid?.category_id || leadTypeValue || "",
    attachmentIds: taskid?.attachments || [],
    parent_task_id: (RowData && RowData?.id) || (taskid?.isDuplicateTask && taskid?.parent_task_id) || null,
  };
  const isParent = taskid?.parent_task_id === null;
  const isSubTask = taskid?.parent_task_id;
  const isOpenSubTask = taskid?.parent_task_id === null ? false : RowData?.subTask === true ? true : false;
  const isDuplicateTask = taskid?.isDuplicateTask;
  const isCopyToTask = taskid?.isCopyToTask;
  const listSubTasks = taskid?.sub_tasks;

  const [formData, setFormData] = useState(initialFormData || {});

  useEffect(() => {
    let existingCustomer = {};

    if (customerId) {
      const filteredItem = customerTaskPodAllCustomer?.data?.customers.find((item) => item.customer_id == customerId);
      existingCustomer = { customer_id: filteredItem?.customer_id, customer_name: filteredItem?.customer_name };
    } else if (selectedCustomer) {
      if (selectedCustomer?.customer_id)
        existingCustomer = {
          customer_id: selectedCustomer?.customer_id,
          customer_name: selectedCustomer?.customer_name,
        };
      else if (selectedCustomer?.id) {
        existingCustomer = { customer_id: selectedCustomer?.id, customer_name: selectedCustomer?.customer_name };
      }
    }

    if (existingCustomer?.customer_id) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        customer_name: (existingCustomer && existingCustomer?.customer_name) || "",
        customer_id: (existingCustomer && existingCustomer?.customer_id) || "",
      }));
    }
  }, [customerTaskPodAllCustomerSuccess, selectedCustomer]);

  const {
    data: customerTaskUserList,
    error: customerTaskUserListerror,
    isLoading: customerTaskUserListLoading,
  } = useFetchCustomerUseListDataQuery({
    token: token?.token,
  });

  // calculate the id be change by cateory id, template id referer to outer category_id
  const CategoryId = GetAlltemplates?.data?.find(
    (template) => template?.template_name?.toLowerCase() === formData?.category_id?.toLowerCase()
  )?.id;

  useEffect(() => {
    const finalTemplateId = CategoryId || templateId;

    if (finalTemplateId) {
      GetLinkedSectionFields({
        TemplateId: finalTemplateId,
        IsForm: true,
        is_company_level: !customerTask,
      });
    }
  }, [CategoryId, templateId]);

  const default_selected = customerTaskUserList?.data?.filter((item) => item.id == userId);

  const initialSubTaskForm = {
    start_date: formData?.start_date,
    assigned_to: [default_selected?.[0]],
    task_type: "new",
    serial: subTaskSerial,
    status: "Not Started",
  };

  const [subTaskForm, setSubTaskForm] = useState(initialSubTaskForm);

  const initialChecklistForm = {
    name: "",
    status: "Not Started",
    checklist_type: "new",
    serial: checklistSerial,
    delegation: [],
  };
  const [checklistForm, setChecklistForm] = useState(initialChecklistForm);

  useEffect(() => {
    setIsFunnelOpen(formData.funnel_id ? true : false);
  }, [formData.funnel_id]);

  useEffect(() => {
    setSubTaskForm(initialSubTaskForm);
  }, [formData?.start_date, subTaskSerial]);

  useEffect(() => {
    setChecklistForm(initialChecklistForm);
  }, [checklistSerial]);

  const subTaskContainerRef = useRef(null);
  const prevSubTasksRef = useRef(formData.sub_tasks);

  const [fetchPersonInTable, { data: personTableData }] = useLazyFetchPersonInTableQuery();

  const [fetchAllProjects, { data: projectsAllData, isFetching: projectsAllDataLoading }] =
    useLazyFetchAllProjectsQuery();
  const [fetchFieldValues, { data: projectFieldList, isFetching: projectFieldListLoading }] =
    useLazyGetProjectTaskEnumQuery();
  const [fetchServiceList, { data: serviceList, isFetching: serviceListLoading }] = useLazyFetchServiceListQuery();
  const { data: customerCommonData, error, isLoading: commonDataLoading } = useFetchCommonDataQuery();
  const [fetchTaskTags, { data: TaskTagsList, isFetching: isTaskTagsLoading }] = useLazyGetTaskTagsQuery();

  useEffect(() => {
    fetchTaskTags("", false);
  }, []);
  useEffect(() => {
    if (commonDataLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
  }, [commonDataLoading]);

  const fetchPersonData = (data) => {
    fetchPersonInTable({ token: token?.token, data: data, companyId: companyId?.company_id });
  };

  const fetchAllProjectsCall = () => {
    fetchAllProjects({ customerId: formData?.customer_id });
  };

  const handleMouseEnter = (index) => {
    setIsSearchBarOpen((prevState) => ({
      ...prevState,
      [index]: true,
    }));
    fetchPersonData("");
  };

  const handleMouseLeave = (index) => {
    setIsSearchBarOpen((prevState) => ({
      ...prevState,
      [index]: false,
    }));
  };

  const openPopup = () => {
    setIsReccurOpen((prev) => !prev);
    setActivity(false);
    setShowSubtaskForm(false);
    setIsAttachmentOpen(false);
    setIsFunnelOpen(false);
    setIsLinkOpen(false);
  };

  const closePopupRecur = () => {
    setIsReccurOpen(false);
  };

  useEffect(() => {
    if (formData?.selection === "specific" || formData?.is_recurrence === 0) {
      setFormData((prevData) => ({
        ...prevData,
        update_single_occurrence: 1,
        update_entire_series: 0,
      }));
    } else if (formData?.selection === "entire" || formData?.is_recurrence === 1) {
      setFormData((prevData) => ({
        ...prevData,
        update_single_occurrence: 0,
        update_entire_series: 1,
      }));
    }
  }, [formData.selection, formData.is_recurrence]);

  useEffect(() => {
    if (subTaskContainerRef.current) {
      // Compare previous and current subtask length to detect addition
      if (formData.sub_tasks?.length > prevSubTasksRef.current?.length) {
        // Scroll to the bottom if a new subtask was added
        subTaskContainerRef.current.scrollTop = subTaskContainerRef.current.scrollHeight;
      }

      // Update the reference to the current subtask list
      prevSubTasksRef.current = formData.sub_tasks;
    }
  }, [formData.sub_tasks]);

  const getInitialStartDate = () => {
    const today = new Date();
    const todayStart = new Date();
    todayStart.setHours(0, 0, 0, 0);

    // 2. Duplicate task logic
    if (isDuplicateTask && taskid?.start_date) {
      const original = new Date(taskid.start_date);

      // original < today → use today
      if (original < todayStart) {
        return new Date(); // today's date with current time
      }

      return original;
    }

    // 3. If formData has start_date → use it
    if (formData?.start_date) {
      return new Date(formData.start_date);
    }

    // 4. OpenSubTask → use RowData start_date
    if (isOpenSubTask && RowData?.start_date) {
      return new Date(RowData.start_date);
    }

    // 5. Default → today
    return today;
  };

  const [startDate, setStartDate] = useState(getInitialStartDate);

  const cross = true;

  const [endDate, setEndDate] = useState(
    isOpenSubTask ? new Date(RowData.end_date) : !showEndDate ? getDatePlusOne(new Date()) : new Date()
  );

  useEffect(() => {
    setFormData(initialFormData);
    if (isSubTask) {
      setStartDate(new Date(taskid?.start_date));
      setEndDate(new Date(taskid?.end_date));
      setFormData((prevData) => ({
        ...prevData,
        status: taskid?.status,
      }));
    }
    if (isDuplicateTask) {
      setFormData({
        ...formData,
        subject: `${formData?.subject}_Copy`,
        status: "Not Started",
      });
    }
  }, [taskid]);

  useEffect(() => {
    if (startDate > endDate) {
      setEndDate(getDatePlusOne(startDate));
    }
  }, [startDate, endDate]);

  const [activity, setActivity] = useState(activeModal ? true : false);

  const handleCheck = (index, event) => {
    setSearchTerm((prevState) => ({
      ...prevState,
      [index]: event.target.value,
    }));
  };

  const ActivateRecur = (recurrdata) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      ...recurrdata,
    }));
    closePopupRecur();
  };

  useEffect(() => {
    setFormData((prevState) => ({
      ...prevState,
      start_date: startDate ? startDate.toISOString() : "",
      end_date: endDate ? endDate.toISOString() : "",
    }));
  }, [startDate, endDate]);

  const validationRules = useMemo(
    () => ({
      customer_id: {
        required: true,
        errorMessage: "Customer Name is Required.",
        compulsory: true,
      },
      subject: {
        required: true,
        errorMessage: "Subject is required.",
        compulsory: true,
      },
      assigned_to: {
        required: true,
        errorMessage: "task must be assigned.",
        compulsory: true,
      },
      sub_tasks: {
        required: true,
        errorMessage: "sub_tasks ",
        // compulsory: category_id?.toLowerCase()==="task",
      },
      project_id: {
        required: true,
        errorMessage: "Project Name is required.",
        compulsory: formData?.category_id?.toLowerCase() === "project",
      },
      service_id: {
        required: true,
        errorMessage: "Service Type is required",
        compulsory: formData?.category_id?.toLowerCase() === "project",
      },
      start_date: {
        required: true,
        errorMessage: "Job Start Date is required.",
        compulsory: formData?.category_id?.toLowerCase() === "project",
      },
      end_date: {
        required: true,
        errorMessage: "Job Start End is required.",
        compulsory: formData?.category_id?.toLowerCase() === "project",
      },
      category_id: {
        required: true,
        errorMessage: "Category is required.",
        compulsory: true,
      },
      // due_date: {
      //   required: true,
      //   errorMessage: 'Due is required.',
      // }
    }),
    [formData?.category_id]
  );

  useEffect(() => {
    if (!taskid) return;

    setStartDate(getInitialStartDate());

    if (taskid?.end_date) {
      setEndDate(new Date(taskid.end_date));
    }
  }, [taskid?.start_date, taskid?.end_date]);

  const [showRemark, setShowRemark] = useState(false);

  // const [categoryChange, setCategoryChange] = useState({});
  const [category, setCategory] = useState({ name: "category_id", value: leadTypeValue });

  const handleGerneralInputChange = (event) => {
    // event.preventDefault();
    const { name, value } = event.target;

    if ((name === "target_delivery_date" || name === "billing_date") && value == "Invalid date") {
      return;
    }

    // Handle showing remark based on category_id value (for example, if it's 17)
    if (value === "17") {
      setShowRemark(true);
    } else {
      setShowRemark(false);
    }
    if (name === "task_pod") {
      if (value === "addNew") {
        setOpenAddNewPodModal(true);
        setFormData((prevFormData) => ({ ...prevFormData, task_pod: "" }));

        return;
      }
    }

    // }

    // Handle the status change for the main task and update subtasks
    if (name === "status") {
      // Update the main task status
      setFormData((prevFormData) => {
        const newStatus = value;

        // Update subtasks based on the new main task status
        const updatedSubTasks = taskid?.sub_tasks?.map((subtask) => {
          // Update subtask status if not already one of the selected statuses
          if (
            newStatus === "Completed" &&
            subtask.status !== "Completed" &&
            subtask.status !== "Drop" &&
            subtask.status !== "Cancelled"
          ) {
            return { ...subtask, status: "Completed" };
          } else if (
            newStatus === "Drop" &&
            subtask.status !== "Completed" &&
            subtask.status !== "Drop" &&
            subtask.status !== "Cancelled"
          ) {
            return { ...subtask, status: "Drop" };
          } else if (
            newStatus === "Cancelled" &&
            subtask.status !== "Completed" &&
            subtask.status !== "Drop" &&
            subtask.status !== "Cancelled"
          ) {
            return { ...subtask, status: "Cancelled" };
          }
          return subtask;
        });

        return {
          ...prevFormData,
          status: newStatus, // Update the main task status
          sub_tasks: updatedSubTasks || [], // Update the subtasks
        };
      });
    }

    if (name === "category_id") {
      if (formData?.category_id?.toLowerCase() === "project" && value?.toLowerCase() !== "project") {
        setCategory({ name: "category_id", value: value });
        setOpenConfirmationDialog("discard_project_and_switch_to_other_task");
      } else if (
        formData?.category_id?.toLowerCase() === "task" &&
        value?.toLowerCase() !== "task" &&
        formData["sub_tasks"]?.length
      ) {
        setCategory({ name: "category_id", value: value });
        setOpenConfirmationDialog("discard_subtask_and_switch_to_non-task");
      } else {
        setLeadTypeValue(value);
        setFormData((prevFormData) => ({
          ...prevFormData,
          [name]: value,
        }));
      }
    } else {
      setFormData((prevFormData) => {
        return {
          ...prevFormData,
          [name]: value,
        };
      });
    }

    setActivity(false);
    // setShowSubtaskForm("");
    setIsReccurOpen(false);
  };

  const handleInputChange = (event) => {
    // event.preventDefault();
    const { name, value } = event.target;

    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));

    setActivity(false);
    // setShowSubtaskForm("");
    setIsReccurOpen(false);
  };

  const handleCategoryUpdate = () => {
    const { name, value } = category || {};
    setLeadTypeValue(value);
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
      ...(value?.toLowerCase() === "task" && { assigned_to: prevFormData.assigned_to.slice(0, 1) }),
      sub_tasks: [],
    }));
  };

  const handleRemoveSubtasks = () => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      sub_tasks: [],
    }));
  };

  const handleRemoveChecklist = () => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      checklists: [],
    }));
  };

  //form submitted function
  const handleSubmitTask = async (event) => {
    event.preventDefault();

    if (!formData?.customer_id) {
      dispatch(
        pushAlert({
          message: "Please select customer name",
          type: "danger",
          visible: true,
        })
      );
      return;
    } else if (!formData?.subject) {
      dispatch(
        pushAlert({
          message: "Please enter task name",
          type: "danger",
          visible: true,
        })
      );
      return;
    }

    const CategoryId = GetAlltemplates?.data?.find(
      (template) => template?.template_name?.toLowerCase() === formData?.category_id?.toLowerCase()
    )?.id;

    const typeTemplateId = CategoryId || templateId;

    const newformdata = { ...formData, ...transformFormPayload(formData, extractOtherSections(headerField)) };

    const {
      frequency,
      interval,
      day_of_month,
      day_of_week,
      start_date,
      end_date,
      update_entire_series,
      weekly_days,
      yearly_option,
      occurrences,
      monthly_week,
      monthly_option,
      daily_option,
      parent_task_id,
      ...RemFormData
    } = newformdata;

    const recurrence = {
      frequency,
      interval,
      day_of_month,
      day_of_week,
      start_date,
      end_date,
      weekly_days,
      yearly_option,
      occurrences,
      monthly_week,
      monthly_option,
      daily_option,
    };

    const OnlyDynamicFields = { ...RemFormData, start_date, end_date };

    const payload = {
      row_id: isDuplicateTask || isCopyToTask ? null : taskid ? taskid?.id : null,
      template_id: typeTemplateId,
      data: OnlyDynamicFields,
      parent_task_id: parent_task_id ? parent_task_id : null,
      // recurrence,
      // update_single_recurrence: taskid && newformdata?.update_single_occurrence ? true : false,
      update_single_recurrence: isDuplicateTask || isCopyToTask || isOpenSubTask ? false : taskid?.id ? true : false,
      edit_entire_recurrence: taskid && newformdata?.update_entire_series ? true : false,
    };
    if (newformdata?.is_recurrence) {
      payload.recurrence = recurrence;
    }
    if (externalApi) {
      externalApi?.createUpdateTask(newformdata);
    } else {
      createUpdateTask({
        data: payload,
        url: `${NODE_URL}template/create-task?template_id=${propTemplateId}&row_id=${propTemplateId ? taskid?.id : null}`,
      });
    }
  };

  useEffect(() => {
    if (!taskid) return;

    if (taskid?.end_date === taskid?.start_date) {
      setShowEndDate(false);
    } else {
      setShowEndDate(true);
    }

    if (taskid?.start_time === "null" || taskid?.end_time === "null") {
      setShowTime(false);
    }
  }, [taskid]);

  useEffect(() => {
    if (customerTaskUserList) {
      const default_selected = customerTaskUserList?.data?.filter((item) => item?.id == userId);
      setFormData((prevFormData) => {
        const alreadyExists = prevFormData?.assigned_to.some(
          (item) => item?.id === default_selected[0]?.id // Assuming objects have an 'id' field for uniqueness
        );

        if (alreadyExists || taskid) {
          return prevFormData; // Return the previous state without changes
        }

        return {
          ...prevFormData,
          assigned_to: [...prevFormData?.assigned_to, default_selected[0]],
        };
      });

      setSubTaskForm((prevFormData) => ({
        ...prevFormData,
        assigned_to: [default_selected?.[0]],
      }));

      setChecklistForm((prevFormData) => ({
        ...prevFormData,
        delegation: [default_selected?.[0]],
      }));
    }
  }, [customerTaskUserList, subTaskSerial, checklistSerial]);

  const tableDetail = {
    tableidclass: "taskmodelowner",
  };

  const getUniversalTaskType = (value) => {
    if (value) {
      if (formData?.category_id === "project") {
        return "project";
      } else {
        return "task";
      }
    }
    return "";
  };
  const { data: newTaskpodsAll, refetch: refetchAllTaskpods } = useFetchAllTaskPodsQuery({
    token: token?.token,
    type: getUniversalTaskType(formData?.category_id),
    customerId: formData?.customer_id ?? "",
    companyId: parsedCompanyData?.company_id,
  });

  useEffect(() => {
    if (GetAlltemplates) {
      const transformedTemplates = GetAlltemplates?.data?.map((template) => ({
        label: template?.template_name,
        value: template?.template_name, // or any custom value
        rightTab: String(template.section_count ?? 0),
        created_at: template?.created_at,
        created_by: template?.created_by,
        updated_at: template?.updated_at,
        updated_by: template?.updated_by,
        id: template?.id,
        is_deployed: template?.is_deployed,
      }));

      setTemplateFormated(transformedTemplates);
    }
  }, [GetAlltemplates]);

  const StartDateChange = (date) => {
    setStartDate(date);
  };

  const generateTimeOptions = () => {
    const times = [];
    for (let i = 0; i < 24; i++) {
      const hour = i < 10 ? `0${i}` : i;
      times.push(`${hour}:00:00`);
      times.push(`${hour}:30:00`);
    }
    return times;
  };

  const StartTimeElement = () => {
    const rawStartTime = formData?.start_time || "00:00:00"; // Default to "00:00:00" if undefined

    return (
      <div className="flex w-full">
        <select
          name="start_time"
          value={rawStartTime}
          onChange={handleInputChange}
          className={`form-select h-[30px] ${isFormDisabled ? "border-DFE2E5 bg-EDEDED text-868686" : "border-DFE2E5 bg-white text-434852"} rounded-md border cursor-pointer focus:outline-hidden focus:ring-0 focus:border-1D5D9B  w-full active:border active:border-DFE2E5 text-xs block h-7 py-0 min-w-fit`}
          disabled={showTime}
        >
          {generateTimeOptions().map((time) => (
            <option key={time} value={time}>
              {time.slice(0, 5)}
            </option>
          ))}
        </select>
      </div>
    );
  };

  const EndTimeElement = () => {
    const rawStartTime = formData?.end_time || "00:00:00";

    return (
      <div className="flex w-full">
        <select
          name="end_time"
          value={rawStartTime}
          onChange={handleInputChange}
          className={`form-select  rounded-md border h-[30px] ${isFormDisabled ? "border-DFE2E5 bg-EDEDED text-868686" : "border-DFE2E5 bg-white text-434852"} focus:outline-hidden focus:ring-0 focus:border-1D5D9B  active:border active:border-DFE2E5 text-xs block w-full h-7 py-0 min-w-fit`}
          disabled={showTime}
        >
          {generateTimeOptions().map((time) => (
            <option key={time} value={time}>
              {time.slice(0, 5)}
            </option>
          ))}
        </select>
      </div>
    );
  };

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    if (name === "showTime") setShowTime(checked);
    if (name === "showEndDate") setShowEndDate(checked);

    if (!checked) {
      if (name === "showTime")
        setFormData((prevFormData) => {
          const newFomData = { ...prevFormData };
          delete newFomData["start_time"];
          delete newFomData["end_time"];
          return newFomData;
        });
      if (name === "showEndDate")
        setFormData((prevFormData) => ({
          ...prevFormData,
          end_date: prevFormData?.start_date,
        }));
    }
  };

  const handleSelectPerson = (event, value, personCountAllowed) => {
    event.preventDefault();

    const isTaskCategory = formData?.category_id?.toLowerCase() === "task";
    const currentAssignedTo = formData.assigned_to || [];

    if (isTaskCategory) {
      const index = currentAssignedTo.indexOf(value);
      if (index === -1) {
        setFormData({
          ...formData,
          assigned_to: [...formData?.assigned_to, value]?.slice(-personCountAllowed),
        });
      } else {
        setFormData({
          ...formData,
          assigned_to: [],
        });
      }
    } else {
      const index = currentAssignedTo.indexOf(value);
      if (index === -1) {
        setFormData({
          ...formData,
          assigned_to: [...formData?.assigned_to, value]?.slice(-personCountAllowed),
        });
      } else {
        setFormData({
          ...formData,
          assigned_to: currentAssignedTo.filter((item) => item !== value),
        });
      }
    }
  };

  const handleRemovePerson = (e, person) => {
    e.stopPropagation();
    setFormData((prevFormData) => ({
      ...prevFormData,
      assigned_to: prevFormData.assigned_to.filter((item) => item.id !== person.id),
    }));
  };

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;

      if (formData?.status && formData?.sub_tasks?.length && formData?.status?.toLowerCase() === "completed") {
        handleMainTaskCheckboxChange({ target: { checked: formData?.status?.toLowerCase() === "completed" } });
      }
    }
  }, [formData]);

  const handleMainTaskCheckboxChange = (e) => {
    const newStatus = e.target.checked ? "Completed" : "Work in Progress";

    setFormData({
      ...formData,
      status: newStatus,
      sub_tasks: formData?.sub_tasks?.map((subtask) => {
        if (
          subtask.status?.toLowerCase() !== "completed" &&
          subtask.status?.toLowerCase() !== "cancelled" &&
          subtask.status?.toLowerCase() !== "drop"
        ) {
          return {
            ...subtask,
            status: newStatus === "Completed" ? "Completed" : "Work in Progress",
          };
        }
        return subtask;
      }),
    });
  };

  const isEditTask = Boolean(taskid?.id);

  const label = { inputProps: { "aria-label": "Checkbox demo" } };
  const isFormDisabled = formDisabledStatuses.includes(formData?.status);

  const handleAddProject = () => {
    setOpenAddProject("add");
  };

  const getFieldValue = async (enumValues, entity = "project") => {
    const payload = {
      entity: entity,
      field: enumValues,
    };
    const response = await fetchFieldValues({ payload }).unwrap();
    if (response?.success) {
      dispatch(pushAlert({ message: response?.message, type: "success", visible: true }));
    } else {
      dispatch(pushAlert({ message: response?.message, type: "danger", visible: true }));
    }
  };

  const getServiceList = () => {
    const payload = {
      customer_id: formData?.customer_id,
    };
    fetchServiceList({ payload });
  };

  function getHideStatus({
    isDuplicateTask,
    isCopyToTask,
    isOpenSubTask,
    isParent,
    isSubTask,
    customerTask,
    hasMyActivities,
  }) {
    if (customerTask) return true;
    if (isDuplicateTask || isCopyToTask || isOpenSubTask || taskid?.id) return true;
    if (isParent || isSubTask) return true;
    if (hasMyActivities === null) return true;
    return false;
  }

  const projectFields0 = [
    {
      id: "customer_id",
      name: "customer_id",
      label: "Customer",
      type: "select",
      value: formData?.customer_id,
      displayValueKey: "customer_name",
      defaultOptions: customerTaskPodAllCustomer?.data?.customers?.map((item) => ({
        label: item.customer_name,
        value: item.customer_id,
      })),
      colspan: "2",
      hide: getHideStatus({
        isDuplicateTask,
        isCopyToTask,
        isOpenSubTask,
        isParent,
        isSubTask,
        customerTask,
        hasMyActivities,
      }),
      isMandatory: true,
      disabled:
        isDuplicateTask || isCopyToTask || customerTask
          ? false
          : Boolean(selectedCustomer?.id || selectedCustomer?.customer_id || taskid?.customer_id || customerId),
      useFetchHook: useLazyGetProjectTaskEnumQuery,
    },
    {
      id: "project_id",
      name: "project_id",
      label: "Project Name",
      type: "select",
      value: formData?.project_id,
      displayValueKey: "project_name",
      disabled: !Boolean(formData?.customer_id),

      apiCall: fetchAllProjectsCall,
      dynamicOptions: projectsAllData?.data?.map((eachItem) => ({
        label: eachItem.project_name,
        value: eachItem.project_id,
      })),
      isLoading: projectsAllDataLoading,
      hide:
        headerField &&
        Object?.entries(headerField)?.some(([sectionLabel]) => sectionLabel === "Project Information") === true
          ? false
          : true,
      colspan: "2",
      addButton: true,
      addButtonLabel: "+ Add New Project",
      addButtonAction: handleAddProject,
      isMandatory: true,
      useFetchHook: useLazyGetProjectTaskEnumQuery,
    },
  ];

  const FunnelLinkTask = [
    {
      id: "funnel_id",
      name: "funnel_id",
      label: formData?.category_id === "project" ? "Tax Milestone" : "Funnel", // as told by bhatia sir on 0107, didnt changed the condition, may be needed to revert it back
      type: "displayValue",
      value: fullHeaderObject && fullHeaderObject?.funnel?.name,
      dynamicOptions: getAllFunnel?.map((eachItem) => ({ label: eachItem?.funnel_name, value: eachItem?.id })),

      useFetchHook: useLazyGetProjectTaskEnumQuery,
      hookPayload: {
        entity: "task",
        field: "funnel_id",
      },
      // disabled: true,
      hide: fullHeaderObject && fullHeaderObject["funnel"] ? false : true || true,
      onClick: (e) => {
        setIsFunnelOpen((prev) => !prev);
      },
    },

    {
      id: "service_id",
      name: "service_id",
      label: "Link To Service",
      type: "select",
      value: formData?.service_id,
      displayValueKey: "service_name",

      colspan: "2",
      noKeyboardNavigation: true,
      childrenKey: "sub_services",
      // apiCall: function () {
      //   return getServiceList();
      // },
      dynamicOptions: serviceList?.data?.map((eachItem) => ({
        label: eachItem?.name,
        value: eachItem?.id,
        children: eachItem?.sub_services?.map((eachTask) => ({
          label: eachTask?.name,
          value: eachTask?.id,
        })),
      })),
      isLoading: serviceListLoading,
      isMandatory: formData?.category_id === "project",
      useFetchHook: useLazyGetProjectTaskEnumQuery,
      hide:
        headerField &&
        Object?.entries(headerField)?.some(([sectionLabel]) => sectionLabel === "Service Information") === true
          ? false
          : true,
    },
  ];

  const projectFields1 = [
    {
      id: "job_name",
      name: "job_name",
      label: "Job Name",
      type: "text",
      value: formData?.job_name,
      disabled: true,
      colspan: "2",
      // isMandatory: true,
      useFetchHook: useLazyGetProjectTaskEnumQuery,
    },

    {
      id: "job_status_funnel",
      name: "job_status_funnel",
      label: formData?.category_id === "project" ? "Tax Milestone" : "Funnel", // as told by bhatia sir on 0107, didnt changed the condition, may be needed to revert it back
      type: "select",
      value: formData?.job_status_funnel,
      // dynamicOptions:projectFieldList?.data?.map((eachItem) => ({ label: eachItem, value: eachItem })),
      isLoading: projectFieldListLoading,
      // apiCall: function() {
      //   return getFieldValue("job_status","job");
      // },
      useFetchHook: useLazyGetProjectTaskEnumQuery,
      hookPayload: {
        entity: "task",
        field: "job_status_funnel",
      },

      hide: !["deal", "project"].includes(formData?.category_id?.toLowerCase()),
      colspan: "2",
    },

    {
      id: "project_period",
      name: "project_period",
      label: "Job Period",
      type: "date",
      noInput: true,
      // value: formData?.project_start_date,
      disabled: true,
      // hide: formData?.category_id !== "project",
      useFetchHook: useLazyGetProjectTaskEnumQuery,
      // noLabel: true,
      colspan: 2,
    },

    {
      id: "project_start_date",
      name: "project_start_date",
      label: "Period Start Date",
      type: "date",
      placeholder: "Job Start Date",
      value: formData?.project_start_date,
      disabled: true,
      noLabel: true,
      // hide: formData?.category_id !== "project",
      useFetchHook: useLazyGetProjectTaskEnumQuery,
      // noLabel: true,
      colspan: 1,
    },
    {
      id: "project_end_date",
      name: "project_end_date",
      label: "Period End Date",
      type: "date",
      placeholder: "Job End Date",
      value: formData?.project_end_date,
      disabled: true,
      noLabel: true,
      // hide: formData?.category_id !== "project",
      useFetchHook: useLazyGetProjectTaskEnumQuery,
      // noLabel: true,
      colspan: 1,
    },
  ];

  const projectFields2 = [
    {
      id: "service_id",
      name: "service_id",
      label: "Link To Service",
      type: "select",
      value: formData?.service_id,
      displayValueKey: "service_name",

      colspan: "2",
      noKeyboardNavigation: true,
      childrenKey: "sub_services",
      apiCall: function () {
        return getServiceList();
      },
      dynamicOptions: serviceList?.data?.map((eachItem) => ({
        label: eachItem?.name,
        value: eachItem?.id,
        children: eachItem?.sub_services?.map((eachTask) => ({
          label: eachTask?.name,
          value: eachTask?.id,
        })),
      })),
      isLoading: serviceListLoading,
      isMandatory: formData?.category_id === "project",
      useFetchHook: useLazyGetProjectTaskEnumQuery,
    },

    {
      id: "return_type",
      name: "return_type",
      label: "Return Type",
      type: "select",
      value: formData?.return_type,
      // dynamicOptions: projectFieldList?.data?.map((eachItem) => ({ label: eachItem, value: eachItem })),
      // isLoading: projectFieldListLoading,
      useFetchHook: useLazyGetProjectTaskEnumQuery,
      hookPayload: {
        entity: "job",
        field: "return_type",
      },
      // apiCall: function() {
      //   return getFieldValue("return_type","job");
      // },
      hide: serviceList?.data
        ? serviceList.data.find((eachItem) => eachItem?.id === formData?.service_id)?.name !== "Tax"
        : formData?.service_name !== "Tax",
    },
    {
      id: "complexity",
      name: "complexity",
      label: "Complexity",
      type: "select",
      value: formData?.complexity,
      hide: serviceList?.data
        ? serviceList.data.find((eachItem) => eachItem?.id === formData?.service_id)?.name !== "Tax"
        : formData?.service_name !== "Tax",
      // dynamicOptions:projectFieldList?.data?.map((eachItem) => ({ label: eachItem, value: eachItem })),
      isLoading: projectFieldListLoading,
      useFetchHook: useLazyGetProjectTaskEnumQuery,
      hookPayload: {
        entity: "job",
        field: "complexity",
      },
      // apiCall: function() {
      //   return getFieldValue("complexity","job");
      // },
    },

    {
      id: "target_delivery_date",
      name: "target_delivery_date",
      label: "Target delivery date",
      type: "date",
      value: formData?.target_delivery_date,
      useFetchHook: useLazyGetProjectTaskEnumQuery,
      disabled: true,
    },

    {
      id: "budgeted_hours",
      name: "budgeted_hours",
      label: "Budgeted hours",
      type: "hours",
      value: formData?.budgeted_hours,
      useFetchHook: useLazyGetProjectTaskEnumQuery,
      disabled: true,
    },
  ];

  const projectFields3 = [
    {
      id: "subject",
      name: "subject",
      label: `${isOpenSubTask || isSubTask ? "Sub Task Name" : "Task Name"}`,
      type: "text",
      value: "subject",
      disabled: true,
      col_span: "2",
      isMandatory: true,
      useFetchHook: useLazyGetProjectTaskEnumQuery,
    },
    {
      id: "priority",
      name: "priority",
      label: "Priority",
      type: "radio",
      value: "priority",
      isChecked: formData?.priority,
      defaultOptions: customerCommonData?.data?.priority?.map((item) => ({ label: item.value, value: item.value })),
      colspan: "2",
      useFetchHook: useLazyGetProjectTaskEnumQuery,

      //   // hide: formData?.category_id === "project",
    },

    {
      id: "job_period",
      name: "job_period",
      label: "Period",
      type: "dateTimeCombo",
      value: formData?.job_period,
      disabled: true,
      // hide: formData?.category_id !== "project",
      col_span: "2",
      noLabel: true,
      isMandatory: true,
      useFetchHook: useLazyGetProjectTaskEnumQuery,
    },
    {
      id: "status",
      name: "status",
      label: "Status",
      type: "select",
      value: "status",
      noDisabled: true,
      defaultOptions: customerCommonData?.data?.status?.map((item) => ({
        label: item.value,
        value: item.value,
        color_code: item?.colour_code,
      })),
      useFetchHook: useLazyGetProjectTaskEnumQuery,
      colspan: "2",
    },
    {
      id: "assigned_to",
      name: "assigned_to",
      label: "Assigned To",
      type: "assigned_to",
      value: formData?.assigned_to,
      colspan: "2",
      isSearchBarOpen: isSearchBarOpen,
      taskassignedtoref: taskassignedtoref,
      handleMouseEnter: handleMouseEnter,
      handleMouseLeave: handleMouseLeave,
      handleCheck: handleCheck,
      personTableData: personTableData,
      handleSelectPerson: handleSelectPerson,
      handleRemovePerson: handleRemovePerson,
      searchTerm: searchTerm,
      isEditTask: isEditTask,
      disabled: Boolean(formData?.status === "Completed"),
      // hide:
      //   headerField &&
      //   Object?.entries(headerField)?.some(([sectionLabel]) => sectionLabel === "Attachment") === true
      //     ? false
      //     : true,
    },
  ];

  const fetchAndSetFieldOptions = async (field) => {
    if (!field?.value || !field?.id) return;

    try {
      if (field?.type === "multi_person" || field?.type === "person") {
        const personDataResponse = await fetchPersonInTable({
          token: getUserToken(),
          data: "",
          companyId: companyId?.company_id,
        });

        let data = personDataResponse?.data;

        if (data?.status && data?.data.length) {
          setDropdownOptionsMap((prev) => ({
            ...prev,
            [field.id]: data?.data,
          }));
        } else {
          setDropdownOptionsMap((prev) => ({
            ...prev,
            [field.id]: [],
          }));
        }

        return;
      }

      // ✅ Normal dropdown API
      const response = await FetchFieldDropDownValues({
        FieldName: field.value,
      }).unwrap();

      if (response?.data?.length) {
        setDropdownOptionsMap((prev) => ({
          ...prev,
          [field.id]: response?.data,
        }));
      } else {
        setDropdownOptionsMap((prev) => ({
          ...prev,
          [field.id]: [],
        }));
      }
    } catch (err) {
      setDropdownOptionsMap((prev) => ({
        ...prev,
        [field.id]: [],
      }));
    }
  };

  const handleRemoveProjectFields = () => {
    setFormData((prevFormData) => {
      const updatedFormData = structuredClone(prevFormData);
      projectFields1?.forEach((key) => delete updatedFormData[key]);
      projectFields2?.forEach((key) => delete updatedFormData[key]);
      return updatedFormData;
    });
  };
  const sectionRefs = useRef({});

  const checkAndPerformOperation = (key) => {
    switch (key) {
      case "all_discard_and_close":
        setCategory({ name: "category_id", value: formData?.category_id });
        setFormData({});
        setOpenConfirmationDialog(false);
        closePopup();
        break;

      case "close_only_confirmation_dialog":
        setCategory({ name: "category_id", value: formData?.category_id });
        setOpenConfirmationDialog(false);

        break;

      case "discard_subtask_and_switch_to_non-task":
        handleRemoveSubtasks();
        handleCategoryUpdate();
        setOpenConfirmationDialog(false);
        setShowSubtaskForm("");

        break;

      case "discard_project_and_switch_to_other_task":
        handleRemoveSubtasks();
        handleRemoveChecklist();
        handleCategoryUpdate();
        handleRemoveProjectFields();
        setOpenConfirmationDialog(false);
        setShowSubtaskForm("");
        break;

      default:
        break;
    }
  };

  //its for gerenal field
  const GerneralFields = ({ projectFields }) => (
    <>
      {projectFields
        ?.filter((item) => !item?.hide)
        .map((eachField) => (
          <div
            className={`basis-5/5 mb-1 col-span-${eachField.colspan ?? "1"}`}
            style={{ margin: eachField?.noInput && "0px" }}
          >
            {!eachField?.noLabel && (
              <LabelComponent
                labelText={eachField?.label}
                htmlFor={eachField?.label}
                size="small"
                className="font-600 text-535252"
                isMandatory={eachField?.isMandatory}
                isFormDisabled={isFormDisabled}
              />
            )}
            {!eachField?.noInput && (
              <div className="flex items-center">
                {eachField?.type === "dateTimeCombo" ? (
                  <DateTimeRecurence
                    innerLabel={"Task Due Date"}
                    name={eachField?.name}
                    showEndDate={showEndDate}
                    showTime={showTime}
                    handleCheckboxChange={handleCheckboxChange}
                    openPopup={() => handleSwitchToggle("recurrence")}
                    isPopupOpen={isReccurOpen}
                    isFormDisabled={isFormDisabled}
                    formData={formData}
                    setIsPopupOpen={setIsReccurOpen}
                    ActivateRecur={ActivateRecur}
                    closePopupRecur={closePopupRecur}
                    taskid={taskid}
                    setStartDate={setStartDate}
                    startDate={startDate}
                    setEndDate={setEndDate}
                    endDate={endDate}
                    StartTimeElement={StartTimeElement}
                    Fragment={Fragment}
                    EndTimeElement={EndTimeElement}
                    setFormData={setFormData}
                    StartDateChange={StartDateChange}
                    isMandatory={eachField?.isMandatory}
                    drawerRef={drawerRef}
                  />
                ) : (
                  <FieldElements
                    {...eachField}
                    id={eachField?.id}
                    name={eachField?.name}
                    label={eachField?.label}
                    placeholder={eachField?.placeholder}
                    value={eachField?.value}
                    displayValueKey={eachField?.displayValueKey}
                    onChange={handleGerneralInputChange}
                    disabled={eachField?.disabled}
                    isFormDisabled={isFormDisabled}
                    // defaultOptions={selectionList}
                    type={eachField?.type}
                    noKeyboardNavigation={eachField?.noKeyboardNavigation}
                    childrenKey={eachField?.childrenKey}
                    formData={formData}
                    taskid={taskid}
                    defaultOptions={eachField?.defaultOptions}
                    dynamicOptions={eachField?.dynamicOptions}
                    apiCall={eachField?.apiCall}
                    addButton={eachField?.addButton}
                    addButtonLabel={eachField?.addButtonLabel}
                    addButtonAction={eachField?.addButtonAction}
                    isLoading={eachField?.isLoading}
                    useFetchHook={eachField?.useFetchHook}
                    hookPayload={eachField?.hookPayload}
                    noDisabled={eachField?.noDisabled}
                    // displayName={eachField?.displayName}
                  />
                )}
              </div>
            )}
          </div>
        ))}
    </>
  );

  // its for DYNAMIC FIELDS
  const DynamicFieldsRender = ({ projectFields }) => (
    <>
      {projectFields
        ?.filter((item) => !item?.hide)
        .map((eachField, idx) => (
          <>
            <div
              key={eachField?.id || eachField?.label || idx}
              className={`basis-1/2 mb-1 col-span-${eachField?.col_span ?? "1"}`} // paylaod response as col_span
              style={{ margin: eachField?.noInput && "0px" }}
            >
              {!eachField?.noLabel && (
                <>
                  <LabelComponent
                    labelText={eachField?.label}
                    htmlFor={eachField?.label}
                    size="small"
                    className="font-600 text-535252"
                    isMandatory={eachField?.isMandatory}
                    isFormDisabled={isFormDisabled}
                  />
                </>
              )}
              {!eachField?.noInput && (
                <div className="flex items-center">
                  {eachField?.type === "dateTimeCombo" ? ( // dateTimeCombo for reccurrence
                    <DateTimeRecurence
                      innerLabel={"Start Date"}
                      name={eachField?.name}
                      showEndDate={showEndDate}
                      showTime={showTime}
                      handleCheckboxChange={handleCheckboxChange}
                      openPopup={openPopup}
                      isPopupOpen={isReccurOpen}
                      isFormDisabled={isFormDisabled}
                      formData={formData}
                      setIsPopupOpen={setIsReccurOpen}
                      ActivateRecur={ActivateRecur}
                      closePopupRecur={closePopupRecur}
                      taskid={taskid}
                      setStartDate={setStartDate}
                      startDate={startDate}
                      setEndDate={setEndDate}
                      endDate={endDate}
                      StartTimeElement={StartTimeElement}
                      Fragment={Fragment}
                      EndTimeElement={EndTimeElement}
                      setFormData={setFormData}
                      StartDateChange={StartDateChange}
                      isMandatory={eachField?.isMandatory}
                      drawerRef={drawerRef}
                      isDisableReccurrence={isOpenSubTask || isSubTask}
                      minDate={isOpenSubTask ? RowData?.start_date : null}
                      maxDate={isOpenSubTask ? RowData?.end_date : null}
                    />
                  ) : (
                    // <></>
                    <FieldElements
                      {...eachField}
                      id={eachField?.value}
                      name={eachField?.value}
                      label={eachField?.label}
                      placeholder={eachField?.placeholder}
                      value={formData && formData[eachField?.value]}
                      displayValueKey={eachField?.displayValueKey}
                      onChange={(e) =>
                        handleInputChange({
                          target: {
                            label: eachField?.label,
                            value: e?.target?.value,
                            name: eachField?.value,
                          },
                        })
                      }
                      disabled={eachField?.disabled}
                      isFormDisabled={isFormDisabled}
                      type={eachField?.type}
                      noKeyboardNavigation={eachField?.noKeyboardNavigation}
                      childrenKey={eachField?.childrenKey}
                      formData={formData}
                      taskid={taskid}
                      defaultOptions={eachField?.defaultOptions}
                      apiCall={eachField?.apiCall}
                      apiCallParam={eachField}
                      dynamicOptions={
                        dropdownOptionsMap?.[eachField?.id]
                        // ? dropdownOptionsMap?.[eachField?.id]?.map((option) => ({
                        //     label: option?.label,
                        //     value: option?.value,
                        //     color_code: option?.color,
                        //     ...(option?.sublabel ? { sublabel: option?.sublabel } : {}),
                        //   }))
                        // : []
                      }
                      addButton={eachField?.addButton}
                      addButtonLabel={eachField?.addButtonLabel}
                      addButtonAction={eachField?.addButtonAction}
                      isLoading={eachField?.isLoading}
                      useFetchHook={eachField?.useFetchHook}
                      hookPayload={eachField?.hookPayload}
                      noDisabled={eachField?.noDisabled}
                      fetchAndSetFieldOptions={fetchAndSetFieldOptions}
                    />
                  )}
                </div>
              )}
            </div>
          </>
        ))}
    </>
  );

  const handleSwitchToggle = (type) => {
    const currentState = {
      funnel: isFunnelOpen,
      attachment: isAttachmentOpen,
      subtask: subTaskList,
      link: isLinkOpen,
      activity: activity,
      recur: isReccurOpen,
    };

    const isSamePanelOpen = currentState[type];

    // close all panels
    setIsFunnelOpen(false);
    setIsAttachmentOpen(false);
    setSubTaskList(false);
    setIsLinkOpen(false);
    setActivity(false);
    setIsReccurOpen(false);
    setLinkDocumentPreview(false);

    // if same panel was open → just close everything
    if (isSamePanelOpen) return;

    // otherwise open the clicked one
    switch (type) {
      case "funnel":
        setIsFunnelOpen(true);
        break;

      case "attachment":
        setIsAttachmentOpen(true);
        break;

      case "subtask":
        setSubTaskList(true);
        break;

      case "link":
        setIsLinkOpen(true);
        break;

      case "activity":
        setActivity(true);
        break;

      case "recur":
        setIsReccurOpen(true);
        break;

      default:
        break;
    }
  };

  const handleFileUpload = async () => {
    const input = document.createElement("input");
    input.type = "file";
    input.multiple = true;
    input.click();

    input.addEventListener("change", async (event) => {
      const files = Array.from(event.target.files);
      let updatedFiles = [...selectedFiles];
      let lastId = selectedFiles.length > 0 ? selectedFiles[selectedFiles.length - 1].id : 0;

      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const formData = new FormData();
        formData.append("file", file);

        try {
          const response = await postNoteAttachment({ data: formData }).unwrap();

          setSelectedFiles((prevFiles) => [
            ...prevFiles,
            {
              id: response.id,
              attachment: response.filename,
              file: file,
              view_url: response.view_url,
              download_url: response.download_url,
              // uploaded_id: response.id, // optional if you want to track server id
            },
          ]);
        } catch (error) {
          console.error("File upload failed for:", file.name, error);
        }
      }
    });

    return false;
  };

  const handleDeleteFileServer = async (id) => {
    const url = `${CUSTOMER_DELETE_NOTES_ATTACHMENT}${id}`;
    try {
      const newSelectedFiles = selectedFiles?.filter((f) => f.id !== id);
      setSelectedFiles(newSelectedFiles);

      const response = await deleteData(url, getUserToken());
      if (response?.success || response?.data?.success || response?.data?.status) {
        dispatch(pushAlert({ message: "File deleted successfully.", type: "success", visible: true }));
      } else {
        dispatch(pushAlert({ message: "File not deleted successfully.", type: "danger", visible: true }));
      }
    } catch (error) {
      dispatch(pushAlert({ message: "Something went wrong", type: "danger", visible: true }));
    }
  };

  useEffect(() => {
    if (selectedFiles?.length) {
      const ids = selectedFiles?.map((file) => file.id);

      setFormData((prev) => ({
        ...prev,
        attachmentIds: ids,
      }));
    }
  }, [selectedFiles]);

  const measureRef = useRef(null);

  useEffect(() => {
    if (isCopyToTask && templateFormated) {
      setFormData((prev) => ({
        ...prev,
        category_id:
          templateFormated && templateFormated?.filter((item) => item.value !== formData?.category_id)[0]?.value,
      }));
    }
  }, [isCopyToTask, templateFormated]);

  return (
    <CustomDrawer
      open={isOpen}
      onClose={closePopup}
      variant="temporary"
      width="35vw"
      showSubDrawer={
        activity ||
        isLinkOpen ||
        isReccurOpen ||
        ((fullHeaderObject?.funnel?.id ? true : false) && isFunnelOpen) ||
        isAttachmentOpen ||
        subTaskList ||
        linkDocumentPreview
      }
    >
      <div className="flex flex-col h-full w-full " ref={drawerRef}>
        {/* link and sharing options pending,  */}
        <div className="w-full bg-white flex items-center justify-between px-3 py-2 border-b-2">
          <div className="flex items-center text-lg font-medium text-[#131313CC] gap-1">
            {/* { !customerTask ? (taskid?.id ? formData?.customer_name : "Create") : (taskid?.id ? "Edit" : "Create")} */}
            <GetHeaderLabel
              customerTask={customerTask}
              taskid={taskid}
              isOpenSubTask={isOpenSubTask}
              RowData={RowData}
              isDuplicateTask={isDuplicateTask}
              isCopyToTask={isCopyToTask}
              isSubTask={isSubTask}
              isParentTask={isParent}
              handleNavigateParent={handleNavigateParent}
            />

            {isCopyToTask && (
              <div className="flex items-center bg-gray-100 px-2 rounded ">
                {/* hidden span to measure width */}
                <div
                  ref={measureRef}
                  className="flex gap-2 items-center"
                  onClick={() => setCategoryList((prev) => !prev)}
                >
                  <span className="truncate max-w-[15ch] text-lg cursor-pointer font-500 ">
                    {formData?.category_id}
                  </span>
                  <DownArrow
                    fill={`#1D4469`}
                    className={`${categoryList ? "rotate-180" : "rotate-0"} transition-all cursor-pointer duration-300 text-primary-text-muted`}
                  />
                </div>

                {categoryList && (
                  <>
                    <PortalList
                      open={categoryList}
                      onClose={() => setCategoryList(false)}
                      containerRef={measureRef}
                      width="150px"
                      options={
                        (templateFormated &&
                          templateFormated?.filter((item) => item.value !== formData?.category_id)) ||
                        []
                      }
                      selectedOptions={[]}
                      onOptionClick={(data) => {
                        const selectedValue = data[0].value;
                        setFormData((prev) => ({
                          ...prev,
                          category_id: selectedValue,
                        }));
                        setCategoryList(false);
                      }}
                    />
                  </>
                )}
              </div>
            )}
          </div>

          <div className="flex items-center justify-center gap-2">
            <div className="flex items-center justify-center gap-x-2">
              {listSubTasks?.length > 0 && (
                <span
                  onClick={(e) => {
                    e.stopPropagation();
                    handleSwitchToggle("subtask");
                  }}
                  className={`h-6 w-6 group rounded-md cursor-pointer flex items-center justify-center  ${subTaskList ? "bg-primary" : "bg-[#F6F6F6] hover:bg-primary"} `}
                >
                  <SubTaskHeader
                    className={`  ${subTaskList ? "text-white " : "text-gray-400 group-hover:fill-primary"}`}
                  />
                </span>
              )}
              <span
                className={`h-6 w-6 group rounded-md cursor-pointer flex items-center justify-center   ${isAttachmentOpen ? "bg-primary" : "bg-[#F6F6F6] hover:bg-[#F6F6F6]"}`}
                onClick={() => handleSwitchToggle("attachment")}
              >
                <AttachmentTask
                  className={`fill-gray-400  ${isAttachmentOpen ? "fill-white " : "fill-gray-400 group-hover:fill-primary"}`}
                />
              </span>
              {isEditTask && (
                <button
                  className={`h-6 w-6 group rounded-md cursor-pointer flex items-center justify-center   ${activity ? "bg-primary" : "bg-[#F6F6F6] hover:bg-[#F6F6F6]"}`}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleSwitchToggle("activity");
                  }}
                >
                  <MenuBar className={`${activity ? "fill-white " : "fill-gray-400 group-hover:fill-primary"}`} />
                </button>
              )}

              {taskid?.isLinkTask && (
                <button
                  className={`h-6 w-6 group rounded-md cursor-pointer flex items-center justify-center ${isLinkOpen ? "bg-primary" : "bg-[#F6F6F6] hover:bg-[#F6F6F6]"}`}
                  onClick={() => handleSwitchToggle("link")}
                >
                  <LinkTask className={`${isLinkOpen ? "fill-white " : "fill-gray-400 group-hover:fill-primary"}`} />
                </button>
              )}
            </div>

            <button
              onClick={closePopup}
              type="button"
              className="text-454545 bg-transparent hover:bg-F1F5F8 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center"
              data-modal-hide="assets-modal"
            >
              <CloseModalImg className="w-3 h-3" />
              <span className="sr-only">Close modal</span>
            </button>
          </div>
        </div>

        <form
          id={tableDetail?.tableidclass}
          onSubmit={handleSubmitTask}
          className={`w-full flex flex-col justify-start flex-1 grow min-h-0 relative ${tableDetail?.tableidclass}`}
        >
          {/* custom header */}
          <div className=" border-[#BECBD3] px-3 pt-1">
            {GerneralFields({
              projectFields: projectFields0,
            })}
          </div>

          {/* dynamic header/fields */}
          <div className="border-[#BECBD3] px-3 min-h-0 grow overflow-y-auto scrollbar-hidden">
            {/* Fixed Task Information */}
            <div className="flex flex-col min-h-0 grow">
              <div className="grid grid-cols-2  gap-x-2 min-h-0 grow ">
                {DynamicFieldsRender({ projectFields: projectFields3 })}

                {/* Description */}
                <div className="col-span-2">
                  <div className="basis-5/5 mb-3 col-span-3">
                    <LabelComponent
                      labelText="Description"
                      htmlFor="description"
                      size="small"
                      isFormDisabled={isFormDisabled}
                      className="font-600"
                    />
                    <textarea
                      id="description"
                      name="description"
                      placeholder="Type Something..."
                      value={formData?.description}
                      onChange={handleInputChange}
                      className={`rounded border ${
                        isFormDisabled ? "border-DFE2E5 bg-EDEDED text-868686" : "border-DFE2E5 bg-white text-434852"
                      } focus:outline-hidden focus:ring-0 focus:border-1D5D9B text-xs block w-full h-[80px] resize-none`}
                    />
                  </div>
                </div>

                {/* Remarks */}
                {showRemark && (
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4 col-span-2">
                    <div className="basis-5/5 mb-3 px-6 col-span-3">
                      <label htmlFor="remarks" className="font-medium block mb-2 text-sm text-434852">
                        Remarks
                      </label>
                      <textarea
                        id="remarks"
                        name="remarks"
                        placeholder="Type Something..."
                        value={formData?.remarks}
                        onChange={handleInputChange}
                        className="bg-white rounded border border-DFE2E5 focus:outline-hidden focus:ring-0 focus:border-C4D3E2 focus:shadow-10 text-gray-900 text-sm block w-full h-[40px] resize-none"
                      />
                    </div>
                  </div>
                )}
              </div>

              {/* funnel , link to service */}
              <div className=" border-[#BECBD3]">
                {GerneralFields({
                  projectFields: FunnelLinkTask,
                })}
              </div>
            </div>

            {/* Dynamic Sections */}
            {headerField &&
              Object.entries(headerField)
                .filter(
                  ([sectionLabel, fields]) =>
                    !["Project Information", "Service Information", "Task Information", "Funnel Information"].includes(
                      sectionLabel
                    )
                )
                .map(([sectionLabel, sectionData], idx) => (
                  <div key={sectionLabel + idx}>
                    {DynamicFieldsRender({
                      projectFields: sectionData?.fields?.filter((field) => field?.is_visible === 1),
                    })}
                  </div>
                ))}
          </div>

          <div className="sticky bottom-0 self-end border-y w-full flex justify-end border-BECBD3 p-3">
            <button
              onClick={closePopup}
              type="button"
              className="w-28 text-383838 bg-F4F4F4 border border-[#D2DAE1] hover:bg-eeeeee cancel-btn focus:ring-4 focus:ring-blue-300 font-semibold px-5 py-1 text-center rounded-[5px]"
            >
              Cancel
            </button>
            <button
              type="submit"
              className={`w-28 text-white save-btn border border-[#D2DAE1]  font-semibold bg-[#5489FF] py-1 px-5 ms-3 rounded-[5px] 
                              ${
                                !formData.customer_id || (taskid && areObjectsSimilar(initialFormData, formData))
                                  ? "bg-gray-400 cursor-not-allowed"
                                  : "bg-primary-80  hover:bg-primary border-primary hover:text-white"
                              }
                            `}
            >
              Save
            </button>
          </div>
        </form>
      </div>

      {activity && (
        <CustomerEditTaskActivity
          activityid={taskid?.id}
          // activity={activity}
          // handleActivity={handleActivity}
          // cross={cross}
          open={activity}
          onClose={() => handleSwitchToggle("activity")}
          type="Task"
          // parallelDrawer
          subDrawer
        />
      )}
      {isLinkOpen && (
        <LinkedDrawer
          open={isLinkOpen}
          data={initialFormData}
          onClose={() => {
            setIsLinkOpen(false);
            setActivity(false);
          }}
          taskId={taskid?.id}
          parentType="TASK"
          selectedCustomer
          subDrawer
        />
      )}

      {openConfirmationDialog && (
        <ConfirmationDialogBox
          open={openConfirmationDialog}
          onClose={() => {
            checkAndPerformOperation("close_only_confirmation_dialog");
          }}
          onConfirm={() => {
            checkAndPerformOperation(openConfirmationDialog);
          }}
        >
          <div>
            {formData?.sub_tasks?.some((subtask) => subtask.subject !== "")
              ? "Changing the task category will remove all associated sub-tasks."
              : ""}
            {formData?.sub_tasks?.some((subtask) => subtask.subject !== "") && <br />}
            Do you want to discard the changes you have done.?
          </div>
        </ConfirmationDialogBox>
      )}
      {openAddNewPodModal && (
        <div>
          <AddNewPodModal
            open={openAddNewPodModal}
            onClose={() => setOpenAddNewPodModal(false)}
            taskid={taskid?.id}
            category_id={formData?.category_id}
            customerId={taskid?.customer_id || formData?.customer_id}
            refetchPods={refetchAllTaskpods}
          />
        </div>
      )}
      {openAddProject && (
        <AddViewProjectDrawer
          open={openAddProject}
          setOpen={setOpenAddProject}
          onClose={() => setOpenAddProject(false)}
          customerTaskPodAllCustomer={customerTaskPodAllCustomer}
          setJobFormData={setFormData}
          projectId={formData?.project_id}
          getFieldValue={getFieldValue}
          projectFieldList={projectFieldList}
          fetchPersonInTable={fetchPersonData}
          personTableData={personTableData}
          selectedCustomer={selectedCustomer || { id: formData?.customer_id }}
          refetchGetAllTasks={refetchGetAllTasks}
        />
      )}

      {/* funnel subDrawer */}
      {(fullHeaderObject && fullHeaderObject?.funnel ? true : false) && isFunnelOpen && (
        <SubDrawerRenderer
          subDrawer
          open={(fullHeaderObject && fullHeaderObject?.funnel ? true : false) && isFunnelOpen}
          headerText="Stages"
          onClose={() => handleSwitchToggle("funnel")}
        >
          <FunnelSubDrawer
            taskid={taskid}
            activeFunnel={formData?.funnel_id}
            funnelStages={funnelStages}
            setFunnelStages={setFunnelStages}
            Funnel={fullHeaderObject && fullHeaderObject?.funnel}
            coloredStyle
          />
        </SubDrawerRenderer>
      )}

      {/* attachment subDrawer */}
      {isAttachmentOpen && (
        <SubDrawerRenderer
          subDrawer
          open={isAttachmentOpen}
          headerText="Attachments"
          onClose={() => handleSwitchToggle("attachment")}
        >
          <AttachmentSubDrawer
            selectedFiles={selectedFiles}
            setSelectedFiles={setSelectedFiles}
            handleFileUpload={handleFileUpload}
            handleDeleteFileServer={handleDeleteFileServer}
            AttachmentLoading={postNoteAttachmentLoading}
            coloredStyle
          />
        </SubDrawerRenderer>
      )}
      {/* subTask subDrawer */}
      {subTaskList && (
        <SubDrawerRenderer
          subDrawer
          open={subTaskList}
          headerText="Sub Task"
          onClose={() => setSubTaskList((prev) => !prev)}
        >
          <SubTaskListSubDrawer
            SubTaskslist={(taskid && listSubTasks) || []}
            handleSubTaskCardClick={handleSubTaskCardClick}
            setSubTaskList={setSubTaskList}
            refetch={refetchGetAllTasks}
          />
        </SubDrawerRenderer>
      )}

      {/* preview link task to doucment */}
      {linkDocumentPreview && (
        <SubDrawerRenderer
          subDrawer
          open={linkDocumentPreview}
          headerText="Link Document"
          onClose={() => setLinkDocumentPreview(false)}
        >
          <div className="w-full h-full bg-white">
            <LinkedDocsCard
              info={{
                id: "97dacfd0-e5d9-47fe-bb7a-c9eb21eb089f",
                document_name: "nest-cli.json",
                file_path:
                  "https://gfpointernalstorage1.blob.core.windows.net/gfpointernal/-3f43aec0-01b0-47eb-8eec-5c34fe45b443-nest-cli.json%22",
                folder_id: "3c498d8d-b2f5-4a5e-86cd-1863262a3308",
                document_container_id: null,
                access: "private",
                created_by: "Person",
                created_at: "2025-12-08T12:56:04.000Z",
                updated_by: null,
                updated_at: "2025-12-08T12:56:04.000Z",
                status: "pending",
                description: "",
                serial_number: 200,
                size: 224,
                blob_name: "-3f43aec0-01b0-47eb-8eec-5c34fe45b443-nest-cli.json",
                session_id: null,
                auto_id: 22,
              }}
              highlightText={highlightText}
            />
          </div>
        </SubDrawerRenderer>
      )}
    </CustomDrawer>
  );
};
export default DynamicAddTaskPodModal;
